export default class {

    constructor (lodash) {
        this.lodash = lodash;
    }

    /**
     * This function re-nests object arrays under eachother
     * ex: const example = {
     *      'key1' => [
     *          {id: 1},
     *          {id: 2}
     *      ],
     *      'key2' => [
     *          {trainingId: 1, language: 'ET'},
     *          {trainingId: 2, language: 'ET'}
     *      ]
     * }
     * nestModel(example, 'key1', 'key2', 'trainingId', 'id', 'language')
     * example = {
     *      'key1' => [
     *          {
     *              id: 1,
     *              key2: [
     *                  'ET': {trainingId: 1, language: 'ET'}
     *              ]
     *          },
     *          {
     *              id: 2,
     *              key2: [
     *                  'ET': {trainingId: 2, language: 'ET'}
     *              ]
     *          }
     *      ]
     * }
     * @param obj object to re-nest
     * @param from property name where the from array is located in object
     * @param to property name where the to array is located in object
     * @param compareFrom key in moved objects that will be matched against compareTo
     * @param compareTo key in to array objects that will be matched against compareFrom
     * @param key optional if from prop is object,used to store said obj. if array, each key is taken from from[key]
     * @param objectNesting optional default false, if set true, considers from as a single object instead of array
     */
    nestModel (obj, from, to, compareFrom, compareTo, key = undefined, objectNesting = false) {
        if (this.lodash.isEmpty(obj[from]) || this.lodash.isEmpty(obj[to])) {
            return;
        }
        const indexes = {};
        this.lodash.forEach(obj[to], (toObj, index) => {
            this.lodash.forEach(obj[from], (fromObj) => {
                if (fromObj[compareFrom] === toObj[compareTo]) {
                    indexes[toObj[compareTo]] = this.lodash.get(indexes, toObj[compareTo], -1) + 1;
                    const toPath = [to, index];
                    if (key && objectNesting) {
                        toPath.push(key);
                    }
                    else {
                        toPath.push(from);
                        if (key) {
                            toPath.push(this.lodash.get(fromObj, key));
                        }
                        else if (!objectNesting) {
                            toPath.push(indexes[toObj[compareTo]]);
                        }
                    }
                    this.lodash.set(obj, toPath.join('.'), fromObj);
                }
            });
        });
        delete obj[from];
    }
}



// WEBPACK FOOTER //
// ./src/app/services/common/index.js